import { GetServerSideProps } from 'next'
import { useTranslation } from '../src/utils/convergence'
import React, { ReactElement } from 'react'

import { Head, TerminalError } from '../src/component'
import { withPreventBrowserNavigation } from '../src/component/withPreventBrowserNavigation'
import { getLayout } from '../src/layouts/MainLayout'
import { CheckoutPage } from '../src/model'
import { useCheckoutError, useErrorCode } from '../src/state'
import { TrackPageViewed } from '../src/integrations/monitoring'
import { useCompleteCheckoutJourneyOnTerminalError } from '../src/integrations/userJourney'

import { createCombinedServerSideProps } from '../src/utils/server/page-props'

const I18N_NAMESPACE = ['common', 'terminalError']

const OhNo: CheckoutPage = (): ReactElement => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const checkoutError = useCheckoutError()
  const errorCode = useErrorCode()

  useCompleteCheckoutJourneyOnTerminalError()

  return (
    <>
      <Head title={t('common:brandName')} />
      <TerminalError {...checkoutError} />
      <TrackPageViewed
        eventProperties={{
          error: errorCode,
          terminalError: checkoutError?.error,
          isInitialLimit: checkoutError?.extra?.isInitialLimit,
        }}
      />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = createCombinedServerSideProps(I18N_NAMESPACE)

const OhNoPage: CheckoutPage = withPreventBrowserNavigation(OhNo)
OhNoPage.getLayout = getLayout({ useFailureUrlForClose: true })
export default OhNoPage
